import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" className="icp-license">京ICP备16025769号-5</a>
        <p className="copyright">© 2024 Shao's Sky 天文摄影</p>
      </div>
    </footer>
  );
};

export default Footer;